// extracted by mini-css-extract-plugin
export default {"general":"CodesList_general--scO","option":"CodesList_option--Lhv","title":"CodesList_title--t4B","s":"CodesList_s--BO3","m":"CodesList_m--yrk"};